import Store from "../Store/Store";
import Time from "../Time/Time";
// import { replace } from "react-router-redux";

class Formatter {
  public toFixed(num, fixed) {
    var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    return num.toString().match(re)[0];
  }

  public formatSigns = (amount: string): string => {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (!amount) {
      return "";
    }

    if (amount.indexOf('-') > -1) {
      amount = amount.replace('-', '');
    }

    if (settings.locale.iso === "nl-NL") {
      if (amount.indexOf('.') > -1) {
        return amount.replace('.', '');
      }
    }

    if (settings.locale.iso === "en-US") {
      if (amount.indexOf(',') > -1) {
        return amount.replace(',', '');
      }
    }

    return amount;
  }

  public transformFromCents = (num: number): number => {
    return num ? parseFloat((num / 100).toFixed(2)) : 0;
  }

  public simpleFormatNumber = (num: number, cents: boolean = true, withDecimals:boolean = true): string => {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (cents) {
      num = this.transformFromCents(num);
    }

    let formatted = withDecimals ? (Math.round(num * 100) / 100).toFixed(2) : String(num);

    if (settings === null) {
      return "";
    }

    if (settings.data.language.iso === "nl-NL") {
      formatted = withDecimals ?
                                  ((Math.round(num * 100) / 100).toFixed(2).replace(".", ",")).trim() :
                                  (String(num).replace(".", ",")).trim();
    }

    return formatted;
  }

  public simpleFormatNumberForReport = (num: number, cents: boolean = true, withDecimals:boolean = true): string => {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (cents) {
      num = this.transformFromCents(num);
    }

    let formatted = withDecimals ? (Math.round(num * 100) / 100).toFixed(2) : String(num);

    if (settings === null) {
      return "";
    }

    if (settings.locale.iso === "nl-NL") {
      formatted = withDecimals ?
                                  ((Math.round(num * 100) / 100).toFixed(2).replace(".", ",")).trim() :
                                  (String(num).replace(".", ",")).trim();
    }

    return formatted;
  }

  // Converts from cents (BE storage unit) and localizes. With no `currency`,
  // returns the number only. With a `currency`, appends the ISO code (e.g.
  // "1.234,56 EUR").
  public formatNumber(num: number, currency: any = null): string {
    if (!num && num !== 0 && !currency) {
      return "";
    }

    const settings = Store.getConfigurator().getState().app.settings.user;

    if(!!num){
      num = this.transformFromCents(num);
    } else {
      num = 0;
    }

    if (settings === null) {
      return "";
    }

    if (currency === null) {
      const formatted = num.toLocaleString(settings.locale.iso, {
        style: "currency",
        currency: settings.currency.getIso()
      });

      return formatted.replace(settings.currency.getSymbol(), "").replace(/\s/g, '');
    }

    const formatted = num.toLocaleString(settings.locale.iso, {
      style: "currency",
      currency: currency.getIso()
    }).trim();

    const replaced = formatted.replace(settings.currency.getSymbol(), "").trim();

    return replaced + " "  + currency.getIso();
  }

  public formatNumberWithoutMinus(num: number, currency: any = null): string {
    if (!num && num !== 0 && !currency) {
      return "";
    }

    const settings = Store.getConfigurator().getState().app.settings.user;

    if(!!num){
      num = Math.abs(num);
      num = this.transformFromCents(num);
    } else {
      num = 0;
    }

    if (settings === null) {
      return "";
    }

    if (currency === null) {
      const formatted = num.toLocaleString(settings.locale.iso, {
        style: "currency",
        currency: settings.currency.getIso()
      });

      return formatted.replace(settings.currency.getSymbol(), "").replace(/\s/g, '');
    }

    const formatted = num.toLocaleString(settings.locale.iso, {
      style: "currency",
      currency: currency.getIso()
    }).trim();

    const replaced = formatted.replace(settings.currency.getSymbol(), "").trim();

    return replaced + " "  + currency.getIso();
  }

  public formatDate(date: Date | null): string {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (date === null || settings === null) {
      return "";
    }

    return new Date(date).toLocaleDateString(settings.locale.iso);
  }

  public formatDateDependsOnLanguage(date: Date | null, language: string): string {
    if (date === null || !language) {
      return "";
    }

    const settings = Store.getConfigurator().getState().app.settings.user;

    return new Date(date).toLocaleDateString(settings.data.language.iso);
  }

  public formatDateDependsOnLanguageForReport(date: Date | null, language: string): string {
    if (date === null || !language) {
      return "";
    };
    const settings = Store.getConfigurator().getState().app.settings.user;

    return new Date(date).toLocaleDateString(settings.locale.iso);
  }

  public formatTime(date: Date | null): string {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (date === null || settings === null) {
      return "";
    }

    return new Date(date).toLocaleTimeString(settings.locale.iso, {hour: '2-digit', minute:'2-digit'});
  }

  public formatDateAndTime(date: Date | null): string {
    const formattedDate = this.formatDate(date);
    const formattedTime = this.formatTime(date);
    return `${formattedDate} ${formattedTime}`;
  }

  public formatTimeAndDate(date: Date | null): string {
    const formattedDate = this.formatDate(date);
    const formattedTime = this.formatTime(date);
    return `${formattedTime} ${formattedDate}`;
  }

  public checkTranslationType(translatedWord: string, label: string, shouldTranslate: boolean = true) {
    if (shouldTranslate) {
      if (translatedWord.indexOf("MISSING") === -1) {
        return translatedWord;
      } 
    }
    
    return label;
  }

  public unitListingFormatDate(date: Date | null): string {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (date === null || settings === null) {
      return "";
    }

    return Time.momentify(date).locale(settings.locale.iso).format("ddd, DD MMM YY");
  }

  public statementPeriodFormatDate(date: Date | null): string {
    const settings = Store.getConfigurator().getState().app.settings.user;
    const format = settings.locale.iso === "en-US" ? "MMMM DD YYYY" : "DD MMMM YYYY"

    if (date === null || settings === null) {
      return "";
    }

    return Time.momentify(date).locale(settings.locale.iso).format(format);
  }

  public paymentInformationFormatDate(date: Date | null): string {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (date === null || settings === null) {
      return "";
    }

    return Time.momentify(date).locale(settings.locale.iso).format("DD MMM YYYY");
  }

  public monthYearFormatDate(date: Date | null): string {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (date === undefined || date === null || settings === null) {
      return "";
    }

    return Time.momentify(date).locale(settings.locale.iso).format("MMMM YYYY");
  }

  public monthShortYearFormatDate(date: Date | null): string {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (date === undefined || date === null || settings === null) {
      return "";
    }

    return Time.momentify(date).locale(settings.locale.iso).format("MMM YYYY");
  }

  public statementFooterFormatDate(date: Date | null): string {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (date === undefined || date === null || settings === null) {
      return "";
    }

    return Time.momentify(date).locale(settings.locale.iso).format("DD MMM YYYY");
  }

  public invoiceAttachmentFormatDate(date: Date | null): string {
    const settings = Store.getConfigurator().getState().app.settings.user;

    if (date === undefined || date === null || settings === null) {
      return "";
    }

    return Time.momentify(date).locale(settings.locale.iso).format("YYYY-MM");
  }

  public monthFullFormatDate(date: Date | null): string {
    const settings = Store.getConfigurator().getState().app.settings.user;
    if (date === undefined || date === null || settings === null) {
      return "";
    };

    return Time.momentify(date).locale(settings.locale.iso).format("MMMM");
  }

  public deleteExtraSpace = (num: string): string => {
    return String(num).split(' ').join('');
  }
}

export default new Formatter();
